import { cn } from "@stacklet/ui";
import SparkMD5 from "spark-md5";

import { getAvatarColorOption, type AvatarColorKey } from "./avatarColors";
import { backgroundColorFormatter, initialsFormatter } from "./formatter";

interface Props {
  name: string;
  email: string;
  size?: number;
  /** When set, renders a flat color swatch (no gravatar photo overlay) for that explicit color choice */
  colorKey?: AvatarColorKey;
}

export function Avatar({ email, name, size = 24, colorKey }: Props) {
  const initials = initialsFormatter(name);
  const emailMd5 = SparkMD5.hash(email);
  const colorOption = colorKey ? getAvatarColorOption(colorKey) : undefined;
  const { background, color } = colorOption
    ? { background: undefined, color: undefined }
    : backgroundColorFormatter(emailMd5);

  const sizeStr = Math.max(size, 250).toString();
  const url = `https://www.gravatar.com/avatar/${emailMd5}?s=${sizeStr}&d=404`;

  const fontSize = size / (1 * Math.max(initials.length, 2));

  return (
    <div
      className={cn(
        "relative inline-flex shrink-0 items-center justify-center rounded-full",
        colorOption?.bgClassName,
        colorOption?.textClassName,
      )}
      style={{
        width: size,
        height: size,
        backgroundColor: background,
        color,
      }}
    >
      <div
        className="absolute select-none font-sans uppercase"
        style={{
          fontSize,
        }}
      >
        {initials}
      </div>
      {colorOption ? null : (
        <div
          className="absolute left-0 top-0 rounded-full bg-cover bg-center bg-no-repeat"
          style={{
            width: size,
            height: size,
            backgroundImage: `url(${url})`,
          }}
        />
      )}
    </div>
  );
}
